import PropTypes from 'prop-types';

export const Props = {
  /**
   * The title if the accordion
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  /**
   * The theme if the accordion (this is also applied to the AcCard element)
   */
  theme: PropTypes.oneOf([
    'default',
    'alpha',
    'alpha_light',
    'omega',
    'omega_light',
    'white',
    'light',
    'subtle',
    'medium',
    'pitch',
    'transparent',
  ]),
  /**
   * If true, the height of the accordion is limited to 200px/20rem
   */
  limited: PropTypes.bool,
  /**
   * If true, the accordion is open by default
   */
  open: PropTypes.bool,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
